import type { ApiErrorPayload } from "@/lib/api/api-envelope"
import { isApiFailureBody } from "@/lib/api/api-envelope"
import { isEntitlementBlockerCode } from "@/features/billing/entitlement-reason-codes"

export class PlanEntitlementBlockedError extends Error {
  override readonly name = "PlanEntitlementBlockedError"

  constructor(readonly detail: ApiErrorPayload) {
    super(detail.message)
  }
}

export function throwIfPlanEntitlementBlocked(body: unknown): void {
  if (!isApiFailureBody(body)) return
  const err = body.error
  const blockers = err.blockers
  const hasBlockers = Array.isArray(blockers) && blockers.length > 0
  if (hasBlockers || isEntitlementBlockerCode(err.code)) {
    throw new PlanEntitlementBlockedError({
      code: err.code,
      message: err.message,
      blockers,
    })
  }
}
